import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { AlertTriangle, CheckCircle } from 'lucide-react';

export function AlertsCard({ alerts }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <AlertTriangle className="text-amber-500" size={18} />Low Stock Alerts
        </CardTitle>
      </CardHeader>
      <CardContent>
        {alerts && alerts.length > 0 ? (
          <div className="space-y-2">
            {alerts.map(function(a, i) {
              return (
                <div key={i} className="p-2 bg-red-50 rounded border border-red-200 flex justify-between">
                  <span className="text-sm font-medium">{a.item_code}</span>
                  <span className="text-red-600 font-bold">{a.percentage}%</span>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="h-32 flex items-center justify-center text-green-600">
            <CheckCircle className="mr-2" size={20} />All stock levels OK
          </div>
        )}
      </CardContent>
    </Card>
  );
}
